import React, { memo, useState, useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import {
  getUserNotifications,
  markAsReadNotification,
  fetchTranslationData,
} from "../../redux/actions/action";
import bell from "../../assets/images/Bell.svg";
import { Image } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { AiOutlineCloseCircle } from "react-icons/ai";
import ReactTimeAgo from "react-time-ago";
import userAvatar from "../../assets/images/Anna.png";
import { resolveNotificationAvatarUrl } from "../../utils/helpers/notificationAvatar";

import en from "javascript-time-ago/locale/en.json";
import TimeAgo from "javascript-time-ago";
import moment from "moment";
import { useRef } from "react";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
TimeAgo.addDefaultLocale(en);

const UserNotificationMenu = () => {
  const dispatch = useDispatch();
  const containerRef = useRef(null);
  const userID = useMemo(() => window.localStorage.getItem("userid"));

  const userNotificationList = useSelector(
    (state) => state.user.userNotifications,
  );
  const [localList, setLocalList] = useState([]);
  const [isPopupOpen, setPopupOpen] = useState(false);

  useEffect(() => {
    dispatch(getUserNotifications(userID));
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setPopupOpen(false);
    }
  };

  useEffect(() => {
    setLocalList(Array.isArray(userNotificationList) ? userNotificationList : []);
  }, [userNotificationList]);

  const anyUnreadNotification = useMemo(() => {
    return localList.some((x) => x.isSeen === false);
  }, [localList]);

  const unreadNotificationCount = useMemo(() => {
    return localList.filter((x) => !x.isSeen).length;
  }, [localList]);

  return (
    <div>
      <div
        style={{ cursor: "pointer", position: "relative" }}
        ref={containerRef}
      >
        {anyUnreadNotification && (
          <NotificationDot unreadNotificationCount={unreadNotificationCount} />
        )}
        <Image
          width={20}
          height={24}
          src={bell}
          onClick={() => setPopupOpen((prev) => !prev)}
        />
        {isPopupOpen && (
          <NotificationPopup
            notifications={localList}
            handleClose={() => setPopupOpen(false)}
          />
        )}
      </div>
    </div>
  );
};

const NotificationDot = () => {
  return (
    <div
      style={{
        position: "absolute",
        top: "-8px",
        right: "-8px",
        backgroundColor: "#F76767",
        border: "1px solid #FFFFFF",
        borderRadius: "50%",
        height: "18px",
        width: "18px",
        color: "#fff",
        fontSize: "9px",
        padding: "1px",
      }}
    ></div>
  );
};

const NotificationPopup = ({ handleClose, notifications }) => {
  const visibleCount = useMemo(() => 10);
  const history = useHistory();
  const dispatch = useDispatch();
  const listRef = useRef(null);

  const userID = useMemo(() => window.localStorage.getItem("userid"));
  const [visibleNotification, setVisibleNotification] = useState(visibleCount);
  const [fetchTransNotificationsList, setFetchTransNotificationsList] =
    useState({});
  const t = (key) => fetchTransNotificationsList?.[key] || "";

  useEffect(() => {
    fetchScreenTranslations("Notifications").then((res) => {
      setFetchTransNotificationsList(res);
    });
  }, []);

  const handleNotificationClick = (item) => {
    if (!item.isSeen) {
      dispatch(markAsReadNotification(item.id, userID));
    }
    const data = item.data ? JSON.parse(item.data) : null;
    if (data) {
      switch (item.notificationType) {
        case "CHAT_ADDED":
          history.push(`/chat?room=${data.groupId}`);
          break;
        case "CHAT_ADMIN":
          history.push(`/chat?room=${data.groupId}`);
          break;
        case "TEAM_JOIN":
          history.push(`/updat-member/${data.userId}`);
          break;
        case "TASK_ASSIGN":
        case "TASK_DUE_DATE_CHANGE":
        case "TASK_DUE_TIME_CHANGE":
        case "TASK_STATUS_CHANGE":
        case "TASK_DUE":
        case "COMMENT_TAGGED":
          window.localStorage.setItem("taskid", data.taskId);
          if (window.location.pathname == "/planboard") {
            window.location.reload();
          } else {
            history.push("/planboard");
          }
          break;
        case "USER_BIRTHDAY":
          if (data.groupId) {
            history.push(
              `/chat?room=${data.groupId || "new"}&userid=${data.userId}`,
            );
          } else {
            handleGeneralNotification({
              notificationType: "CUSTOM",
              text: `User not created! Please check the user details.`,
            });
          }
          break;
        case "QUOTE_SIGNED":
          window.open(data.quoteLink, "_blank");
          break;
        default:
          break;
      }
      handleClose();
    }
  };

  return (
    <div
      style={{
        position: "absolute",
        top: "40px",
        right: "-100px",
        backgroundColor: "#FFFFFF",
        width: "333px",
        height: "565px",
        boxShadow: "0px 5px 10px #3B45581A",
        padding: "12px",
        zIndex: 100,
        cursor: "default",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <div className="d-flex align-items-center justify-content-between">
        <div
          style={{
            color: "#A5A5A5",
            fontSize: "clamp(14px, 1vw, 16px)",
            lineHeight: "clamp(19px, 1vw, 21px)",
            fontWeight: "bold",
          }}
        >
          {t("Tasks Messages")}
        </div>
        <div style={{ cursor: "pointer" }}>
          <AiOutlineCloseCircle onClick={handleClose} size={25} />
        </div>
      </div>
      <div ref={listRef} style={{ flexGrow: 1, overflowY: "auto" }}>
        {notifications.slice(0, visibleNotification).map((item, index) => (
          <NotificationItem
            key={`notification-item-${index}`}
            item={item}
            onClickNotification={handleNotificationClick}
            userID={userID}
            dispatch={dispatch}
          />
        ))}
      </div>
      {visibleNotification < notifications.length && (
        <div>
          <div
            style={{
              color: "#00246A",
              fontSize: "clamp(14px, 1vw, 16px)",
              lineHeight: "clamp(19px, 1vw, 21px)",
              fontWeight: "bold",
            }}
            onClick={() => {
              setVisibleNotification((prev) => prev + visibleCount);

              requestAnimationFrame(() => {
                if (listRef.current) {
                  listRef.current.scrollTo({
                    top: listRef.current.scrollHeight,
                    behavior: "smooth",
                  });
                }
              });
            }}
          >
            {t("Load more...")}
          </div>
        </div>
      )}
    </div>
  );
};

const NotificationItem = ({ item, onClickNotification, userID, dispatch }) => {
  const shortName = useMemo(() => {
    let name = "";
    let nameArray = item?.title?.split(" ");
    nameArray?.forEach((x) => (name += x.charAt(0)));
    if (name?.trim().length != 2) name = item?.title?.substring(0, 2);
    return name?.toUpperCase();
  }, [item]);
  let specificDate = moment.utc(item.createdAt).local();
  let diffInDays = moment().diff(specificDate, "days");
  if (diffInDays > 30 && !item.isSeen)
    dispatch(markAsReadNotification(item.id, userID));

  return (
    <div
      className="d-flex justify-content-between py-2 border-bottom border-top px-1"
      style={{
        backgroundColor: item.isSeen ? "transparent" : "#F1F1F1",
        cursor: "pointer",
      }}
      onClick={() => onClickNotification(item)}
    >
      <div className="d-flex align-items-center gap-2">
        <div
          className="d-flex align-items-center justify-content-center"
          style={{
            height: "47px",
            width: "47px",
            borderRadius: "50%",
            backgroundColor: "#95A7C6",
            overflow: "hidden",
            color: "#FFF",
          }}
        >
          {item.senderPicture ? (
            <img
              src={resolveNotificationAvatarUrl(item.senderPicture)}
              alt={item.senderName}
              width="100%"
              height="100%"
              style={{ objectFit: "cover" }}
              onError={(event) => {
                event.currentTarget.src = userAvatar;
              }}
            />
          ) : (
            <span>{shortName}</span>
          )}
        </div>
        <div
          className="d-flex flex-column align-items-start gap-1"
          style={{ maxWidth: "77%" }}
        >
          <div
            style={{
              color: "#333333",
              fontSize: "clamp(14px, 1vw, 16px)",
              lineHeight: "clamp(19px, 1vw, 21px)",
              fontWeight: "bold",
            }}
          >
            {item.title}
          </div>
          <div
            style={{
              color: "#A5A5A5",
              fontSize: "clamp(12px, 1vw, 14px)",
              lineHeight: "clamp(14px, 1vw, 16px)",
              fontWeight: "normal",
              textAlign: "start",
              textOverflow: "ellipsis",
              overflow: "hidden",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              display: "-webkit-box",
            }}
          >
            {item.description}
          </div>
        </div>
      </div>
      <div className="d-flex flex-column align-items-end justify-content-between">
        <div
          style={{
            color: "#A5A5A5",
            fontSize: "clamp(11px, 1vw, 13px)",
            lineHeight: "clamp(15px, 1vw, 17px)",
            fontWeight: "normal",
            minWidth: "45px",
            textAlign: "end",
          }}
        >
          <ReactTimeAgo
            date={moment.utc(item.createdAt).local().toDate()}
            locale="en-US"
            timeStyle="twitter"
          />
        </div>
        {!item.isSeen && (
          <div
            style={{
              backgroundColor: "#F76767",
              height: "20px",
              width: "20px",
              borderRadius: "50%",
              border: "1.5px solid #FFFFFF",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#FFFFFF",
              fontSize: "clamp(10px, 1vw, 12px)",
              lineHeight: "clamp(14px, 1vw, 16px)",
              fontWeight: "normal",
            }}
          >
            1
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(UserNotificationMenu);
